const areLineNameEqual = (name1, name2) => {
  return (
    name1.replace(/ /g, "").toUpperCase() ===
    name2.replace(/ /g, "").toUpperCase()
  );
};
export default areLineNameEqual;
